import {IInsuranceFamily} from "@/model/InsuranceFamily/InsuranceFamily"

export interface IHasInsuranceFamily {
    setInsuranceFamily(insuranceFamily: IInsuranceFamily): void
    getInsuranceFamily(): IInsuranceFamily | null
}

function hasInsuranceFamily<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasInsuranceFamily {
        private insuranceFamily: IInsuranceFamily | null = null

        constructor(...args: any[]) {
            super(...args);
        }

        public getInsuranceFamily(): IInsuranceFamily | null {
            return this.insuranceFamily
        }
        public setInsuranceFamily(insuranceFamily: IInsuranceFamily) {
            this.insuranceFamily = insuranceFamily
        }
    };
}

export default hasInsuranceFamily